module.exports = __webpack_public_path__ + "img/建材行业结构示意图.ccd1e18e.jpg";